import { SET_SIDEBAR } from './types'

const initialState = {
  sidebar: {},
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_SIDEBAR:
      return {
        ...state,
        sidebar: { ...state.sidebar, ...action.payload },
      }

    default:
      return state
  }
}
export default reducer
